import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import StaffForm from "../Staff/StaffForm";
import {
  updateStaffApi,
  getStaffByIdApi
} from "../../api/staffService";
import FullPageLoader from "../../common/FullPageLoader";
const EditAdmin = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const staffId = location?.state?.staffId;
  const [staffData, setStaffData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [pageLoading, setPageLoading] = useState(true);
  const loadAdmin = async () => {
    try {
      setPageLoading(true);
      const res = await getStaffByIdApi(staffId);
      setStaffData(res?.data || res);
    } catch (error) {
        return;
    } finally {
      setPageLoading(false);
    }
  };
   useEffect(() => {
    if (!staffId) {
      console.log("Staff ID not found");
      navigate("/user/clinics/view");
      return;
    }
    loadAdmin();
  },[staffId, navigate]);
  const handleUpdate = async (formData) => {
    try {
      setLoading(true);
      await updateStaffApi(staffId, formData);
      navigate("/user/clinics/view");
    } catch (error) {
      console.log("Update Error:", error);
    } finally {
      setLoading(false);
    }
  };
  if (pageLoading) {
    return <FullPageLoader text="Loading admin details..." />;
  }
  return (
    <div className="container mt-4">
      <StaffForm
        initialData={{
          fullName: staffData?.fullName || "",
          gender: staffData?.gender || "",
          email: staffData?.email || "",
          clinics:
            typeof staffData?.clinics === "string"
              ? staffData.clinics
              : Array.isArray(staffData?.clinics) && staffData.clinics.length > 0
                ? staffData.clinics[0]._id || staffData.clinics[0] || ""
                : "",
        }}
        onSubmit={handleUpdate}
        loading={loading}
      />
    </div>
  );
};
export default EditAdmin;
